import React from 'react';
import { AnalisarResponse, unidadeLabel } from 'services/price_intelligence';
import { Container } from './styles';

interface PriceIntelligenceClarificationProps {
  analise: AnalisarResponse;
  detalhes: string;
  onChangeDetalhes: (valor: string) => void;
  onConfirmar: () => void;
  buscando: boolean;
}

const PriceIntelligenceClarification = ({
  analise,
  detalhes,
  onChangeDetalhes,
  onConfirmar,
  buscando,
}: PriceIntelligenceClarificationProps) => {
  const dicas = analise.clarificacao.perguntas.map((p) => {
    const base = p.pergunta.replace(/\?+\s*$/, '');
    if (p.tipo === 'escolha' && p.opcoes && p.opcoes.length)
      return `${base} (ex.: ${p.opcoes.join(', ')})`;
    if (p.tipo === 'quantidade' && p.unidade) return `${base} (em ${unidadeLabel(p.unidade)})`;
    return base;
  });

  const dicasUnicas = dicas.filter((d, i, todas) => todas.indexOf(d) === i);
  const temResposta = Boolean(detalhes.trim());

  return (
    <Container>
      <div className="clarify-head">
        <span className="clarify-icon">
          <i className="material-icons">smart_toy</i>
        </span>
        <div>
          <p className="clarify-title">Antes de pesquisar, me ajuda a acertar o alvo</p>
          {analise.clarificacao.motivo && (
            <p className="clarify-reason">{analise.clarificacao.motivo}</p>
          )}
        </div>
      </div>

      {dicasUnicas.length > 0 && (
        <div className="clarify-hints">
          <div className="hints-label">O que ajuda a acertar a pesquisa</div>
          <ul>
            {dicasUnicas.map((dica) => (
              <li key={dica}>{dica}</li>
            ))}
          </ul>
        </div>
      )}

      <textarea
        className="form-control"
        rows={4}
        value={detalhes}
        onChange={(e) => onChangeDetalhes(e.target.value)}
        placeholder="Descreva com suas palavras — especificações, material, capacidade, condições… Ex.: notebook i5, 16GB RAM, SSD 512GB, tela 15,6”"
        aria-label="Detalhes da pesquisa"
      />
      <p className="clarify-help">
        Quanto mais contexto, mais precisa fica a pesquisa — a IA usa esse texto para refinar a
        busca.
      </p>

      <div className="clarify-actions">
        <button
          type="button"
          className="btn btn-primary btn-ia d-flex align-items-center"
          onClick={onConfirmar}
          disabled={buscando}
        >
          <i className="material-icons mr-1" style={{ fontSize: 18 }}>
            search
          </i>
          {temResposta ? 'Pesquisar com essas informações' : 'Pesquisar assim mesmo'}
        </button>
      </div>
    </Container>
  );
};

export default PriceIntelligenceClarification;
